"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllLabRequisitionsList = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const useAllLabRequisitionsList = (params) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [allLabRequisitions, setAllLabRequisitions] = (0, react_1.useState)({
        results: [],
        nextCursor: null,
    });
    const fetchAllLabRequisitions = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext, selectedOrgUser, params) => __awaiter(void 0, void 0, void 0, function* () {
        yield selectedOrgUser.allLabRequisitionsManager.fetchAllLabRequisitions(params, abortContext);
        setAllLabRequisitions(selectedOrgUser.allLabRequisitionsManager.allLabRequisitionsData);
    }), utils_1.Constants.API_DEBOUNCE_DELAY_IN_MS);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (selectedOrgUser) {
                try {
                    setIsLoading(true);
                    yield fetchAllLabRequisitions(selectedOrgUser, params);
                }
                finally {
                    setIsLoading(false);
                }
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, selectedOrgUser]);
    return {
        allLabRequisitions,
        isLoading,
    };
};
exports.useAllLabRequisitionsList = useAllLabRequisitionsList;
